import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import OrangeCircularProgress from "../ui/progress/circularProgress";
import PrimaryButton from "../ui/buttons/primaryButton";

function SpeakToAConsultantFeedback({ open, onClose, loading, success }) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      sx={{ textAlign: "center" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 4,
        }}
      >
        {loading ? (
          <OrangeCircularProgress caption="Sending Request" />
        ) : (
          <>
            {success && (
              <TaskAltOutlinedIcon
                color="success"
                sx={{ width: 200, height: 200, mb: 3 }}
              />
            )}

            <DialogTitle sx={{ fontSize: "1.8rem", fontWeight: 600, mb: 1 }}>
              Thank you for reaching out to us!
            </DialogTitle>

            <DialogContent>
              {success ? (
                <Typography variant="body1">
                  Your request has been sent and a <br /> consultant will
                  contact you shortly
                </Typography>
              ) : (
                <Typography variant="body1">
                  Something went wrong, please try again later.
                </Typography>
              )}
            </DialogContent>

            <Box mt={4}>
              <PrimaryButton
                sx={{ width: 150 }}
                onClick={onClose}
                color="primary"
              >
                Close
              </PrimaryButton>
            </Box>
          </>
        )}
      </Box>
    </Dialog>
  );
}

export default SpeakToAConsultantFeedback;
